import { action, makeObservable, ObservableMap, ObservableSet } from 'mobx';
class RegionCache {
    constructor() {
        Object.defineProperty(this, "map", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new ObservableMap()
        });
        makeObservable(this, {
            get: action.bound,
        });
    }
    get(...ids) {
        const key = this.getKey(...ids);
        const t = this.map.get(key) || new ObservableSet();
        this.map.set(key, t);
        return t;
    }
    getKey(...ids) {
        return ids.filter(Boolean).join('.');
    }
    values() {
        const values = Array.from(this.map.values());
        const flatValues = values.flatMap((s) => Array.from(s));
        return new Set(flatValues);
    }
}
const CacheByType = new RegionCache();
class ComponentRegionCache extends RegionCache {
    constructor(uuid) {
        super();
        Object.defineProperty(this, "uuid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.uuid = uuid;
    }
    get(...ids) {
        return super.get(this.uuid, ...ids);
    }
    getAll(breakpoint, locale) {
        const globalRegions = this.get();
        const globalBreakRegions = this.get(breakpoint);
        const localeRegions = this.get(locale);
        const localeBreakRegions = this.get(locale, breakpoint);
        return new Set([
            ...globalRegions,
            ...globalBreakRegions,
            ...localeRegions,
            ...localeBreakRegions,
        ]);
    }
}
export { CacheByType as default, CacheByType, ComponentRegionCache, RegionCache };
//# sourceMappingURL=region-cache.js.map